import type { CanActivateFn, UrlTree } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { inject, Injector, PLATFORM_ID } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter, first, map } from 'rxjs';

import { CartStore } from '../../feature/cart/cart.store';

export const hasCartItemsGuard: CanActivateFn = () => {
	const basket = inject(CartStore).basket();
	const injector = inject(Injector);
	const router = inject(Router);

	if (!isPlatformBrowser(inject(PLATFORM_ID))) {
		return true;
	} else if (!basket) {
		return router.createUrlTree(['/']);
	}

	const state = basket.state();

	const checkState = (): boolean | UrlTree => {
		if (basket.state().loaded) {
			if (basket.items().length) return true;
			return router.createUrlTree(['/cart']);
		}
		return router.createUrlTree(['/']);
	};

	if (state.loading) {
		return toObservable(basket.state, { injector }).pipe(
			filter(({ loading }) => !loading),
			first(),
			map(checkState)
		);
	}

	return checkState();
};
